@use "../../../../styles/text";
@use "../../../../styles/icon-sizes";

:host {
  display: flex;
  margin-bottom: var(--spacing-xxs);

  ::slotted(label) {
    color: var(--color-text-base);
    @include text.text-body-sm;
    min-height: var(--text-body-line-height-sm);
  }

  ::slotted(input[type="checkbox"]) {
    height: var(--text-body-line-height-sm);
    flex: 0 0 auto;
  }

  .validation-icon {
    &[name="system-error"] {
      --system-color: var(--color-error-base);
    }

    &[name="system-success"] {
      --system-color: var(--color-success-base);
    }
  }

  .checkbox-wrapper {
    display: inline-flex;
    min-height: var(--text-body-line-height-sm);
    align-items: flex-start;
    column-gap: var(--spacing-xs);
  }
}

:host(.valid) {
  .checkbox-wrapper {
    border: 2px solid var(--color-success-base);
    padding: var(--spacing-xxs);
  }
}

:host(.invalid) {
  .checkbox-wrapper {
    border: 2px solid var(--color-error-base);
    padding: var(--spacing-xxs);
  }
}

:host(:last-of-type) {
  margin-bottom: 0;
}
